export default '/build/f1548fb4.png'